/**
 * Parse YouTube ProviderAsset keys of the established form `yt:{videoId}`.
 *
 * Playback identity only. Does not create canonical Recording IDs and does
 * not treat hashed `b32.*` document segments as IFrame video ids.
 */

const YOUTUBE_PROVIDER_PREFIX = 'yt:';
const SAFE_YOUTUBE_VIDEO_ID = /^[A-Za-z0-9_.~-]{1,180}$/;

export function parseYoutubeProviderAssetKey(providerAssetKey) {
  if (typeof providerAssetKey !== 'string') return null;
  const raw = providerAssetKey.trim();
  if (!raw.startsWith(YOUTUBE_PROVIDER_PREFIX)) return null;
  const videoId = raw.slice(YOUTUBE_PROVIDER_PREFIX.length);
  if (!videoId || videoId.startsWith('b32.')) return null;
  if (!SAFE_YOUTUBE_VIDEO_ID.test(videoId) || videoId === '.' || videoId === '..') {
    return null;
  }
  return {
    provider: 'youtube',
    videoId,
  };
}

export function youtubeMqThumbnailUrl(videoId) {
  if (typeof videoId !== 'string' || !SAFE_YOUTUBE_VIDEO_ID.test(videoId.trim())) {
    return '';
  }
  return `https://i.ytimg.com/vi/${videoId.trim()}/mqdefault.jpg`;
}
